import { render, staticRenderFns } from "./detailModel.vue?vue&type=template&id=a2db27b0&scoped=true&"
import script from "./detailModel.vue?vue&type=script&lang=js&"
export * from "./detailModel.vue?vue&type=script&lang=js&"
import style0 from "./detailModel.vue?vue&type=style&index=0&id=a2db27b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2db27b0",
  null
  
)

export default component.exports